export const errorMessages = {
  TH: {
    authenWrongCred: 'ข้อมูลอีเมลล์หรือรหัสผ่านไม่ถูกต้อง',
    authenDisabled: 'บัญชีนี้ถูกระงับการใช้งานกรุณาติดต่อผู้ดูแลระบบ',
    authenEmailWrongCred: 'อีเมลล์นี้ไม่มีอยู่ในระบบ',
    addHospitalHintLogo: 'อัพโหลด รูปขนาดไม่เกิน 200k',
    addHospitalLogoBigger: 'ไม่สามารถอัพโหลดขนาดเกิน 200k ได้',
    addHospitalHospitalNameMissing: 'กรุณาระบุชื่อโรงพยาบาล',
    addHospitalHospitalIDMissing: 'กรุณาระบุหมายเลขไอดีโรงพยาบาล',
    addHospitalHospitalIDDuplicate: 'หมายเลขไอดีโรงพยาบาลถูกใช้งานแล้ว',
    addHospitalHospitalOrderNumber: 'กรุณาระบุลำดับการแสดงผลเป็นหมายเลข',
    addUserRequiredName: 'กรุณาระบุชื่อผู้ดูแล',
    addUserRequiredEmail: 'กรุณาระบุอีเมลล์',
    addUserFormatEmail: 'รูปแบบอีเมลล์ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง',
    addUserRequiredPhone: 'กรุณาระบุเบอร์โทรศัพท์',
    addUserRequiredPassword: 'กรุณาระบุรหัสผ่าน',
    addUserPasswordLength: 'รหัสผ่านต้องมีความยาวมากกว่า 6 ตัวอักษร',
    addUserPasswordConfirm: 'รหัสผ่านไม่ตรงกับที่ระบุไว้ในระบบ',
    addUserEmailExisted: 'อีเมลล์นี้มีอยู่ในระบบอยู่แล้ว',
    siteDetailEditLogoHeader: 'กรุณาเลือกรูปโลโก้ที่ต้องการเปลี่ยนแปลง',
    siteDetailEditLogoRequiredName: 'กรุณาเลือกรูปโลโก้ที่ต้องการอัพโหลด',
    addServiceRequiredName: 'กรุณาระบุชื่อจุดบริการ',
    addServiceRequiredDisplayId: 'กรุณาระบุหมายเลขจุดบริการ',
    addServiceDuplicateDisplayId: 'หมายเลขไอดีจุดบริการถูกใช้งานแล้ว',
    addServiceRequiredLatLong: 'กรุณาระบุละติจูดและลองจิจูด',
    addServicePatternLatLong: 'กรุณาระบุพิกัดในรูปแบบของ ละติจูด,ลองจิจูด',
    addServicePatternRadius: 'กรุณาระบุระยะห่างในรูปแบบของตัวเลขที่มากกว่า 1 แต่มีทศนิยมหลักเดียว',
    addServiceRequiredNumQueues: 'กรุณาระบุจำนวนคิวในการแจ้งเตือนล่วงหน้า',
    addServiceMinNumQueues: 'จำนวนคิวในการแจ้งเตือนล่วงหน้าต้องมีค่ามากกว่า 1',
    editServiceNumReservedQueues: 'จำนวนคิวที่จองในแต่ช่วงเวลาต้องมีค่ามากกว่า 1',
    loginRequiredEmail: 'กรุณาระบุอีเมลล์',
    loginFormatEmail: 'รูปแบบอีเมลล์ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง',
    loginRequiredPassword: 'กรุณาระบุรหัสผ่าน',
    loginCheckYourEmail: 'ระบบกำลังส่งลิ้งเพื่อตั้งค่ารหัสผ่านใหม่ไปยังอีเมลที่ท่านระบุไว้กรุณาตรวจสอบอีเมลของท่านอีกครั้ง',
    loginAlertHeader: 'Automatic Blood Collection System',
    changePasswordWrongOldPassword: 'รหัสผ่านไม่ถูกต้อง',
    changePasswordPasswordMissMatch: 'รหัสผ่านไม่ตรงกัน',
    changePasswordInputOldPassword: 'กรุณาใส่รหัสผ่านเก่า',
    changePasswordInputNewPassword: 'กรุณาใส่รหัสผ่านใหม่',
    changePasswordInputConfirmPassword: 'กรุณายืนยันรหัสผ่านใหม่',
  }
};
